// Parent Class
import { Dispatch } from "./dispatch"
import { vsprintf } from "sprintf-js"
import axios from "axios"
import files from "../assets/files.json"

export class Event {
    public headline: string
    public body: string
    public type: string
    public url: string
    public strings: any[] | undefined
    public dispatches?: Dispatch[]

    constructor(headline: string, url: string, dispatches?: Dispatch[], strings?: any[]) {
        this.headline = headline
        this.body = ""
        this.url = url
        this.dispatches = dispatches
        this.type = "event"
        this.strings = strings
        this.text()
    }

    public async text() {
        const foo: any = files
        this.body = (await axios.get(foo[this.url])).data
        if (this.strings) { this.body = vsprintf(this.body, this.strings) }
    }
}
// Game Events: Market Conditions, Fines/No Fines, Turn Instructions, General Instructions, Energy Headlines

// tslint:disable-next-line: max-classes-per-file
export class MarketConditionsEvent extends Event {
    constructor(url: string, dispatches?: Dispatch[]) {
        super("Market Conditions", url, dispatches)
        this.type = "market"
    }
}

// tslint:disable-next-line: max-classes-per-file
export class FinesEvent extends Event {
    constructor(strings: string[], fine: number, dispatches?: Dispatch[]) {
        const fineDispatch = new Dispatch("editMoney", -fine)
        if (dispatches != null) {
            dispatches.push(fineDispatch)
        } else {
            dispatches = [fineDispatch]
        }
        super("Fines!", "fines", dispatches, strings)
    }
}

// tslint:disable-next-line: max-classes-per-file
export class NoFinesEvent extends Event {
    constructor(strings: string[], dispatches?: Dispatch[]) {
        super("No Fines", "nofines", dispatches, strings)
    }
}

// tslint:disable-next-line: max-classes-per-file
export class EnergyHeadlinesEvent extends Event {
    constructor(url: string, strings: any[], dispatches?: Dispatch[]) {
        super("Energy Headlines!", url, dispatches, strings)
        this.type = "energy"
    }
}

// tslint:disable-next-line: max-classes-per-file
export class TurnEvent extends Event {
    constructor(url: string, strings: any[], dispatches?: Dispatch[]) {
        super(
            "Your Turn",
            url,
            dispatches,
            strings
        )
        this.type = "turn"
    }
}

// Misc Events: Game Win / Loss (should these even be considered events???)
